import { AdminInformationFileViewModel } from "./AdminInformationFileViewModel";
import Enumerable from "linq";
export class AdminInformationViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.informationNo = data.informationNo;
        this.startAt = data.startAt;
        this.endAt = data.endAt;
        this.weight = data.weight;
        this.target = data.target;
        this.nyukyokeiyakuNo = data.nyukyokeiyakuNo;
        this.buknCd = data.buknCd;
        this.departmentCode = data.departmentCode;
        this.isEmailNotification = data.isEmailNotification;
        this.emailNotificationDate = data.emailNotificationDate;
        this.emailNotificationHour = data.emailNotificationHour;
        this.emailNotificationMinute = data.emailNotificationMinute;
        this.subject = data.subject;
        this.main = data.main;
        this.isResponseRequired = data.isResponceRequired;
        this.affirmativeText = data.affirmativeText;
        this.negativeText = data.negativeText;
        this.negativeNotificationDepartment = data.negativeNotificationDepartment;
        this.responseDeadline = data.responseDeadline;
        this.existingFiles = Enumerable.from(data.existingFiles).select(x => new AdminInformationFileViewModel(x)).toArray();
        this.buknName = data.buknName;
        this.keiyakusyaName = data.keiyakusyaName;
        this.isCopy = data.isCopy;
    }
    model = null;
    informationNo = null;
    startAt = "";
    endAt = "";
    weight = false;
    target = null;
    nyukyokeiyakuNo = null;
    buknCd = null;
    departmentCode = null;
    isEmailNotification = false;
    emailNotificationDate = "";
    emailNotificationHour = null;
    emailNotificationMinute = null;
    subject = "";
    main = "";
    isResponseRequired = false;
    affirmativeText = "";
    negativeText = "";
    negativeNotificationDepartment = [];
    responseDeadline = "";
    existingFiles = [];
    newFiles = [];
    buknName = "";
    keiyakusyaName = "";
    /** コピーかどうか */
    isCopy = false;
    /**メール送信設定済みフラグ */
    get isEmailSent() {
        if (!this.model) {
            return false;
        }
        return this.model.isEmailNotification;
    }
    /** 値の変更が行われたかどうか */
    get isDirty() {
        return this.model != null && (this.startAt !== this.model.startAt
            || this.endAt !== this.model.endAt
            || this.weight !== this.model.weight
            || this.isEmailNotification !== this.model.isEmailNotification
            || this.emailNotificationDate !== this.model.emailNotificationDate
            || this.emailNotificationHour !== this.model.emailNotificationHour
            || this.emailNotificationMinute !== this.model.emailNotificationMinute
            || this.subject !== this.model.subject
            || this.main !== this.model.main
            || this.responseDeadline !== this.model.responseDeadline
            || this.affirmativeText !== this.model.affirmativeText
            || this.negativeText !== this.model.negativeText
            || this.negativeNotificationDepartment !== this.model.negativeNotificationDepartment
            || this.newFiles.length > 0
            || this.existingFiles.some(x => x.isDelete));
    }
}
